module.exports = __webpack_public_path__ + "static/media/usa-map.d5f45b13.svg";